import { api } from '../../app/api/baseApi';

const localizationApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getTranslationsByCategory: builder.query<object, any>({
            query: ({ body, locale }) => ({
                url: `localization/v1/messages`,
                params: { category: body },
                method: 'GET',
                ...(locale && {
                    headers: {
                        locale: locale,
                    },
                }),
            }),
        }),
        getOperTranslations: builder.query({
            query: (locale: string) => {
                return {
                    url: 'localization/v1/common/messages/login',
                    method: 'GET',
                    headers: {
                        locale,
                    },
                };
            },
        }),
        getInstructions: builder.query({
            query: (locale) => ({
                url: 'localization/v1/instruction',
                method: 'GET',
                ...(locale && {
                    headers: {
                        locale: locale,
                    },
                }),
            }),
        }),
    }),
});

export const {
    useGetTranslationsByCategoryQuery,
    useLazyGetTranslationsByCategoryQuery,
    useGetOperTranslationsQuery,
    useGetInstructionsQuery,
} = localizationApi;
